module.exports = __webpack_public_path__ + "static/media/powered-by-gamanza-white.049dfd41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/powered-by-gamanza-white.svg
// module id = 68
// module chunks = 0